import React, { Component } from "react";
import { connect } from "react-redux";

import SocialLogin from "./SalesSocialLogin";
import { login } from "../../../action/salesUser_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { axiosInstnace, googleApiKey, setLocalData } from "../../../util/util";
import { toast, ToastContainer } from "react-toastify";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";

class SalesLoginComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gsuite: false,
      email: "",
      Password: "",
      repeatpassword: "",
      changepasswordvalue: "",
      changepassword: false,
      showPasswordField: false
    };
  }
  sendForgotLink = async () => {
    if (
      !this.state.email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    const data = await axiosInstnace.get(endPoints.forgetpassword, {
      params: {
        email: this.state.email,
      },
    });
    if (data.data.statusCode === 200) {
      toast.success("Reset link has been sent to your mail", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
    }
    if (data.data.error && !toast.isActive("1")) {
      toast.error("User does not exist exits", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        toastId: "1",
      });
    }
  };
  LoginEmail = async () => {
    if (!this.state.email || !this.state.password) {
      toast.error("Please enter both email address and password", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (
      !this.state.email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    let { email, password } = this.state;
    let params = { email, password };
    let status = await axiosInstnace.post(
      endPoints.salesUseremailLogin,
      params
    );
    
    if (status.data && status.data.code && status.data.code !== 200) {
      toast.error(status.data.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (
      status.data &&
      status.data.code &&
      status.data.code === 200 &&
      status.data.message === "change password"
    ) {
      this.setState({
        changepassword: true,
      });
      return;
    }
    setLocalData("salesUserInfo", status.data.data);
    setLocalData("userInfo", status.data.data);
    if (
      status.data.data.kycstatus &&
      status.data.data.kycstatus.status === "Verified"
    ) {
      history.push("/tp/incentivedetails");
    } else {
      history.push("/tp/EditKycDetails");
    }
  };
  changePassword = async () => {
    let { changepasswordvalue, repeatpassword, email } = this.state;
    if (changepasswordvalue !== repeatpassword) {
      toast.error("Password and Repeat Password are not Same", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    let params = { email, password: changepasswordvalue };
    let response = await axiosInstnace.post(
      endPoints.salesuserChangePassword,
      params
    );
    
    setLocalData("salesUserInfo", response.data.data);
    setLocalData("userInfo", response.data.data);
    if (
      response.data.data.kycstatus &&
      response.data.data.kycstatus.status === "Verified"
    ) {
      history.push("/tp/incentivedetails");
    } else {
      history.push("/tp/EditKycDetails");
    }
  };

  //Social login
  socialLogin = (user) => {
    const userInfo = user._profile;
    if (user._provider == "google") {
      const id_token = user._token.idToken;
      var email = userInfo.email;
      this.props.login({ id_token, email });
    }
  };

  failedLogin = (err) => {
    console.log("err in g-suit login", err);
    window.location.reload();
  };

  validateIfGMailIDProvided = () =>{
    if(!this.state.email || !this.state.email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )){
        toast.error("Please enter a valid email address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if(this.state.email && this.state.email.match(/gmail\.com\s?$/)){
      // alert('gmail login')
      this.setState({
        gsuite: true,
      });

    }else{
      this.setState({
        showPasswordField: true,
      });
    }
  }

  render() {
    return (
      <div className="review-wrapper">
        <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <a id="logo">
              <img
                className="logo-trans"
                src="../../../assets/images/new_logo.png"
                alt
              />{" "}
              <span
                className="supportlink"
                style={{
                  position: "relative",
                  bottom: "38px",
                  left: "17px",
                  color: "white",
                }}
              >
                <a
                  style={{ color: "white" }}
                  target="_blank"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdZZCgoUVTs007HKEheRJSfLBDMlEjsRdvKUocdMI5-uh5chg/viewform"
                >
                  Support Portal
                </a>{" "}
              </span>
            </a>
          </div>
        </div>
        <div className="review-container login-google">
          {this.state.gsuite && !this.state.changepassword && (
            <div className="review-container-inner">
              <span>Sign in to BigFM Portal</span>
              <SocialLogin
                style={{ width: "250px" }}
                provider="google"
                appId={googleApiKey}
                onLoginSuccess={this.socialLogin}
                onLoginFailure={this.failedLogin}
              >
                <svg
                  width="25"
                  height="25"
                  class="vg py u"
                  style={{ marginRight: "10px" }}
                >
                  <g fill="none" fill-rule="evenodd">
                    <path
                      d="M20.66 12.7c0-.61-.05-1.19-.15-1.74H12.5v3.28h4.58a3.91 3.91 0 0 1-1.7 2.57v2.13h2.74a8.27 8.27 0 0 0 2.54-6.24z"
                      fill="#4285F4"
                    ></path>
                    <path
                      d="M12.5 21a8.1 8.1 0 0 0 5.63-2.06l-2.75-2.13a5.1 5.1 0 0 1-2.88.8 5.06 5.06 0 0 1-4.76-3.5H4.9v2.2A8.5 8.5 0 0 0 12.5 21z"
                      fill="#34A853"
                    ></path>
                    <path
                      d="M7.74 14.12a5.11 5.11 0 0 1 0-3.23v-2.2H4.9A8.49 8.49 0 0 0 4 12.5c0 1.37.33 2.67.9 3.82l2.84-2.2z"
                      fill="#FBBC05"
                    ></path>
                    <path
                      d="M12.5 7.38a4.6 4.6 0 0 1 3.25 1.27l2.44-2.44A8.17 8.17 0 0 0 12.5 4a8.5 8.5 0 0 0-7.6 4.68l2.84 2.2a5.06 5.06 0 0 1 4.76-3.5z"
                      fill="#EA4335"
                    ></path>
                  </g>
                </svg>
                Sign in with Google
              </SocialLogin>
             
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      this.setState({
                        gsuite: false,
                        changepassword: false,
                        showPasswordField: false
                      });
                    }}
                  >
                    Sign in options
                  </a>
               
            </div>
          )}
          {!this.state.gsuite && !this.state.changepassword && (
            <div className="review-container-inner">
              <span>Sign in to BigFM Portal</span>
              <div class="contact_field" style={{ marginTop: "30px" }}>
                <div class="contact_input">
                  <input
                    type="text"
                    name="name"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        email: e.target.value,
                      });
                    }} 
                  />
                </div>
              </div>
              { !this.state.showPasswordField && (
                <button style={{ width: "250px" }} onClick={this.validateIfGMailIDProvided}>
                  Proceed
                </button>
              )}
              { this.state.showPasswordField && (
                <div>
                  <div class="contact_field" style={{ marginTop: "15px" }}>
                    <div class="contact_input">
                      <input
                        type="password"
                        name="name"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            password: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{ textAlign: "right", color: "blue", fontSize: "14px" }}
                    onClick={this.sendForgotLink}
                  >
                    <a>Forgot Password?</a>
                  </div>
                  <button style={{ width: "250px" }} onClick={this.LoginEmail}>
                    Login
                  </button>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      this.setState({
                        gsuite: false,
                        changepassword: false,
                        showPasswordField: false
                      });
                    }}
                  >
                    Sign in options
                  </a>
                </div>
              )}
              
            </div>
          )}
          {this.state.changepassword && (
            <div className="review-container-inner">
              <span>Change your password</span>
              <div class="contact_field" style={{ marginTop: "15px" }}>
                <div class="contact_input">
                  <input
                    type="password"
                    name="Password"
                    placeholder="New Password"
                    value={this.state.changepasswordvalue}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        changepasswordvalue: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div class="contact_field" style={{ marginTop: "15px" }}>
                <div class="contact_input">
                  <input
                    type="password"
                    name="repeat-password"
                    placeholder="Confirm New Password"
                    value={this.state.repeatpassword}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        repeatpassword: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <button style={{ width: "250px" }} onClick={this.changePassword}>
                Change
              </button>
            </div>
          )}
        </div>
        <ToastContainer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => dispatch(login(data)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(null, mapDispatchToProps)(SalesLoginComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/login/Login.jsx